import React, { Component } from 'react';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';

import { BadgeItem } from './BadgeItem.component';
import { ActionType } from './ActionType.enum';
import { ItemType } from './ItemType.enum';

export class SearchItem extends Component {
	onSearchKeyup = e => {
		if (e.keyCode === 13) {
			this.search();
		}
	};

	onSearchInputBlur = e => {
		const { value } = e.target;

		if (value === '') {
			this.raiseActionEvent(ActionType.Delete);
		}
	};

	raiseActionEvent = actionType => {
		const { data, id, onActionTrigger } = this.props;

		// call parent's onActionTrigger method
		onActionTrigger(actionType, ItemType.Search, { ...data, id });
	};

	search = () => {
		const { term } = this.props;

		if (term !== '') {
			this.raiseActionEvent(ActionType.Search);
		}
	};

	onSearchKeyDown = e => {
		const maskRe = new RegExp(/[a-zA-Z0-9-#():.[ ]+$/);

		if (!maskRe.test(e.key)) {
			e.preventDefault();
		}
	};

	render() {
		const {
			term,
			showResult,
			resultCount,
			placeholder = 'Search',
			onSearchInputChange,
			showAdvancedSearch,
			onAdvancedSearchTrigger,
			dataqa = 'search-menu-input',
		} = this.props;

		const wrapperClassName = classNames('search-input-wrapper', {
			'with-advanced-search': showAdvancedSearch,
		});

		return (
			<div className="search-item">
				<div className="search-input">
					<div className={wrapperClassName}>
						<input
							type="text"
							value={term}
							placeholder={placeholder}
							data-qa={dataqa}
							{...{ dataqa }}
							onChange={onSearchInputChange}
							onBlur={this.onSearchInputBlur}
							onKeyUp={this.onSearchKeyup}
							onKeyDown={this.onSearchKeyDown}
							{...{ dataqa }}
						/>
						<div className="search-trigger-wrapper">
							{showAdvancedSearch && (
								<span
									className="pi pi-angle-down"
									onClick={onAdvancedSearchTrigger}
									role="button"
									tabIndex={0}
									aria-label="AdvancedSearch"
									{...{ dataqa: 'search-advanced-search-button' }}
								/>
							)}
							<span
								className="pi pi-search"
								onClick={this.search}
								tabIndex={0}
								role="button"
								aria-label="Search"
								{...{ dataqa: 'search-search-button' }}
							/>
						</div>
					</div>
				</div>

				{showResult && (
					<BadgeItem
						id={0}
						active
						showX
						showBadge={isNumber(resultCount)}
						badge={resultCount}
						dataqa={dataqa}
						onActionTrigger={actionType => this.raiseActionEvent(actionType)}
					/>
				)}
			</div>
		);
	}
}
